import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { createContext } from 'react';
import { BookingRequestExtra } from '../../../../api';

export interface ExtraIncome {
  additionalBonus?: number;
  travelExpenses?: number;
  spentMinutes?: string;
  totalAmount?: number;
}

export interface IExtraIncomeContext {
  requestId: string;
  extraIncome: ExtraIncome;
  isLoading: boolean;
  refetchExtraData?: () => void;
  saveBookingRequestExtra?: UseMutateAsyncFunction<
    BookingRequestExtra,
    unknown,
    { requestId: string; requestBody?: BookingRequestExtra | undefined },
    unknown
  >;
}

export const ExtraIncomeContext = createContext<IExtraIncomeContext>({
  extraIncome: {},
  isLoading: false,
  requestId: '',
});
